// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AttackSurfaceLicenseSupportSchema = z.enum(['NOT_SUPPORTED','SUPPORTED','SUPPORTED_WITH_TORCH'] as const);

export type AttackSurfaceLicenseSupportType = `${z.infer<typeof AttackSurfaceLicenseSupportSchema>}`

export default AttackSurfaceLicenseSupportSchema;
